import { FORMAT, dayjs } from 'utils/date';
import { getCustomerSlotDate } from 'redux/modules/customer-slot/selectors';
import { getCustomerOrderId } from 'redux/modules/sessions/selectors';

const defineFavouritesFilters = ({ start = 0, state = {} } = {}) => {
  const availableDateTimeRange = getCustomerSlotDate(state) || dayjs().format(FORMAT.ISO8601_DATE);
  const trolleyId = getCustomerOrderId(state);

  return {
    ...(trolleyId && { trolleyId }),
    availableDateTimeRange,
    favourites: true,
    start,
  };
};

export default defineFavouritesFilters;
